import {MoreAboutTemplate} from './common/MoreAboutTemplate';

export class Template {
  id: number;
  partnerId: number;
  enterpriseId: number;
  type: string;
  description: string;
  createAt: string;
  content: any;
  path: string;
  fileName: string;
  extension: string;
  active: boolean;
  deleted: boolean;
  showAll: boolean;
  // tslint:disable-next-line:variable-name
  _more?: MoreAboutTemplate;
  moreAboutTemplate?: MoreAboutTemplate;
}
